import Constants from './constants'
import Utils from './utils'
import RemoteLogger from './remoteLogger'

const DIST_M_S = "m/s"
const DIST_MI_H = "mph"
const TEMP_CEL = "C"
const TEMP_FAH = "F"

const MIN_TEMP_CEL = -200
const MIN_TEMP_FAH = -400

export default class SIFormatter {
    static getDistanceUnitForSI(si) {
        switch (si) {
            case Constants.SI_UNIT_BRITISH:
                return DIST_M_S;
            case Constants.SI_UNIT_US:
                return DIST_MI_H
            default:
                return DIST_M_S
        }
    }

    static getTempUnitForSI(si) {
        switch (si) {
            case Constants.SI_UNIT_BRITISH:
                return TEMP_CEL;
            case Constants.SI_UNIT_US:
                return TEMP_FAH;
            default:
                return TEMP_CEL;
        }
    }

    static isTempValInCelcius(tempVal) {
        return tempVal === TEMP_CEL
    }

    /*
    Convert the input temperature into the given SI unit.
    If the given SI and the DEFAULT_SI match, then the original input is given as output.
    The temp can be a string or a number.
    Will *ALWAYS* return a string. Even if original input is being returned.
    The returned value is rounded off to the nearest integer.
    If the value is < 1, then rounded off the 1 place decimal
    */
    static convertTempForSI(si, temp) {
        // Setting the default val to 0 if not string or number
        var tempVal = 0;
        if (typeof (temp) === "string") {
            var intermediateFloat = parseFloat(temp)
            if (false === isNaN(intermediateFloat)) {
                tempVal = intermediateFloat;
            }
        } else if (typeof (temp) === "number") {
            tempVal = temp;
        }

        var finalVal = tempVal;
        // If SI is the same as the default, then don't perform the conversion 
        if (si !== Constants.SI_UNIT_DEFAULT && tempVal !== 0) {
            switch (si) {
                case Constants.SI_UNIT_BRITISH:
                    // Convert from fahrenheit to celcius
                    finalVal = ((tempVal - 32) / 1.8)
                    break

                case Constants.SI_UNIT_US:
                    // Convert from celcius to fahrenheit
                    finalVal = ((tempVal * 1.8) + 32)
                    break
                default:
                // pass
            }
        }

        // If the finalVal is less than 0, allow decimal upto 1 digit
        var convertedVal;
        if (finalVal < 1) {
            convertedVal = Math.round(finalVal * 10) / 10
        } else {
            convertedVal = Math.round(finalVal)
        }
        return '' + convertedVal
    }

    /*
    Convert the input speed into the given SI unit.
    If the given SI and the DEFAULT_SI match, then the original input is given as output.
    The temp can be a string or a number.
    Will *ALWAYS* return a string. Even if original input is being returned.
    The returned value is rounded off to the nearest integer.
    If the value is < 1, then rounded off the 1 place decimal
    */
    static convertSpeedForSI(si, distance) {
        var distanceVal = 0;
        if (typeof (distance) === "string") {
            var intermediateDistanceVal = parseFloat(distance)
            if (false === isNaN(distanceVal)) {
                distanceVal = intermediateDistanceVal;
            }
        } else if (typeof (distance) === "number") {
            distanceVal = distance;
        }

        var finalVal = distanceVal;
        if (si !== Constants.SI_UNIT_DEFAULT && distanceVal !== 0) {
            switch (si) {
                case Constants.SI_UNIT_BRITISH:
                    // Convert from mph to meters/second
                    finalVal = (distanceVal * 0.44704)
                    break;

                case Constants.SI_UNIT_US:
                    // Convert from m/s to miles/hour
                    finalVal = (distanceVal * 2.23694)
                    break;

                default:
                // pass
            }
        }

        // If the finalVal is less than 0, allow decimal upto 1 digit
        var convertedVal;
        if (finalVal < 1) {
            convertedVal = Math.round(finalVal * 10) / 10
        } else {
            convertedVal = Math.round(finalVal)
        }
        return '' + convertedVal
    }

    static isValidCurrentTempForWeatherData(weatherData, generalData) {
        if (Utils.isNull(weatherData) === true || Utils.isNull(weatherData.currTemp) === true) {
            console.log("VALID_CURR: Got empty weather-data or empty weather-data.currTemp")
            return false;
        }

        var currTempStr = weatherData.currTemp;
        var si = Constants.SI_UNIT_DEFAULT;
        if (false === Utils.isNull(generalData) && false === Utils.isNull(generalData.si)) {
            si = generalData.si;
        } else {
            console.log("ERR: GOT EMPTY SI")
        }
        var currTempVal = parseFloat(currTempStr)
        if (false === Utils.isNull(currTempVal) && false === isNaN(currTempVal)) {
            switch (si) {
                case Constants.SI_UNIT_BRITISH:
                    if (currTempVal < MIN_TEMP_CEL) {
                        RemoteLogger.logStr("ERR: Got cel-temperature less than " + MIN_TEMP_CEL);
                        return false;
                    } else {
                        return true;
                    }
                case Constants.SI_UNIT_US:
                    if (currTempVal < MIN_TEMP_FAH) {
                        RemoteLogger.logStr("ERR: Got fah-temperature less than " + MIN_TEMP_FAH);
                        return false;
                    } else {
                        return true;
                    }
                default:
                    RemoteLogger.logStr("ERR: Couldn't understand the SI UNIT - " + si)
                    return false;
            }
        } else {
            console.log("ERR: Error converting current temperature value")
        }
        return false;

    }

    static isValidSIValue(siValue) {
        return (
            false === Utils.isNull(siValue) &&
            (
                siValue === Constants.SI_UNIT_BRITISH ||
                siValue === Constants.SI_UNIT_US
            )
        )
    }

    static convertDistanceForSI(si, distance) {
        var distanceVal = 0;
        if (typeof (distance) === "string") {
            var intermediateDistanceVal = parseFloat(distance)
            if (false === isNaN(distanceVal)) {
                distanceVal = intermediateDistanceVal;
            }
        } else if (typeof (distance) === "number") {
            distanceVal = distance;
        }

        var finalVal = distanceVal;
        if (si !== Constants.SI_UNIT_DEFAULT && distanceVal !== 0) {
            switch (si) {
                case Constants.SI_UNIT_BRITISH:
                    // Convert from mph to meters/second
                    finalVal = distanceVal
                    break;

                case Constants.SI_UNIT_US:
                    // Convert from km to miles
                    finalVal = (distanceVal * 0.621371)
                    break;

                default:
                // pass
            }
        }

        // If the finalVal is less than 0, allow decimal upto 1 digit
        var convertedVal;
        if (finalVal < 1) {
            convertedVal = Math.round(finalVal * 10) / 10
        } else {
            convertedVal = Math.round(finalVal)
        }
        return '' + convertedVal
    }
}


// WEBPACK FOOTER //
// ./src/common/siFormatter.js